import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { HiMagnifyingGlass, HiArrowLeft } from 'react-icons/hi2';
import { FullPageState } from '@/components/common/States';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <FullPageState
      tone="gold"
      glyphSize="lg"
      glyph={<HiMagnifyingGlass />}
      title={t('states.notFound.title')}
      body={t('states.notFound.body')}
      actions={
        <>
          <Button variant="primary" onClick={() => navigate(-1)}>
            <HiArrowLeft className="me-1" aria-hidden />
            {t('states.notFound.back')}
          </Button>
          <Button variant="outline-secondary" onClick={() => navigate('/sprawy')}>
            {t('states.notFound.home')}
          </Button>
        </>
      }
    />
  );
}
